import React from "react";
import FormLayout from "./FormLayout";
import logo from "../../assets/Image/logo.png";
import LoginPage from "./WithUi/LoginPage";
function Login() {
  return (
    <FormLayout logoSrc={logo}   > 
      <LoginPage />
    </FormLayout>
  );
}
export default Login;
